export default "__VITE_ASSET__BdXTsuiP__"